module.exports = __webpack_public_path__ + "static/media/pln_primary_no_dot.e0944ee4.svg";